function convertRømerToCelsius(num) {
  let eq =
    "Converting " +
    num +
    "° rømer to celsius: \n" +
    "(" +
    num +
    " - 7.5)* 40 / 21 = ";
  let rep = ((num - 7.5) * 40) / 21;
  return eq + rep.toFixed(3);
}

function convertRømerToFahrenheit(num) {
  let eq =
    "Converting " +
    num +
    "° rømer to fahrenheit: \n" +
    "(" +
    num +
    " - 7.5) * 24 / 7 + 32 = ";
  let rep = ((num - 7.5) * 24) / 7 + 32;
  return eq + rep.toFixed(3);
}

function convertRømerToKelvin(num) {
  let eq =
    "Converting " +
    num +
    "° rømer to kelvin: \n" +
    "(" +
    num +
    " - 7.5) * 40 / 21 + 273.15 = ";
  let rep = ((num - 7.5) * 40) / 21 + 273.15;
  return eq + rep.toFixed(3);
}

function convertRømerToRankine(num) {
  let eq =
    "Converting " +
    num +
    "° rømer to rankine: \n" +
    "(" +
    num +
    " - 7.5) * 24 / 7 + 491.67 = ";
  let rep = ((num - 7.5) * 24) / 7 + 491.67;
  return eq + rep.toFixed(3);
}

function convertRømerToDelisle(num) {
  let eq =
    "Converting " +
    num +
    "° rømer to delisle: \n" +
    "(60 - " +
    num +
    ") * 20 / 7 = ";
  let rep = ((60 - num) * 20) / 7;
  return eq + rep.toFixed(2);
}

function convertRømerToNewton(num) {
  let eq =
    "Converting " +
    num +
    "° rømer to newton: \n" +
    "(" +
    num +
    " - 7.5) * 22 / 35 = ";
  let rep = ((num - 7.5) * 22) / 35;
  return eq + rep.toFixed(3);
}

function convertRømerToRéaumur(num) {
  let eq =
    "Converting " +
    num +
    "° rømer to réaumur: \n" +
    "(" +
    num +
    " - 7.5) * 32 / 21 = ";
  let rep = ((num - 7.5) * 32) / 21;
  return eq + rep.toFixed(3);
}

export {
  convertRømerToRéaumur,
  convertRømerToNewton,
  convertRømerToDelisle,
  convertRømerToRankine,
  convertRømerToKelvin,
  convertRømerToFahrenheit,
  convertRømerToCelsius
};
